import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { ColumnConfigurator } from "../../../CommonComponents/ColumnConfigurator"
import { toast } from "sonner"
import useLocalStorageState from "use-local-storage-state"

export const ProjectHeader = ({
    columns,
    setColumns,
    columnOptions,
    setOffset,
    setSearch,
    setProjectOffcanvas,
}) => {
    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState("permission")
    const projectGrant = PERMISSION?.project

    const [inputSearch, setInputSearch] = useState("")

    // Debounced search effect
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            setSearch(inputSearch.trim())
            setOffset(0)
        }, 300)
        return () => clearTimeout(debounceTimer)
    }, [inputSearch])

    return (
        <div className="mb-0 pb-1 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
                <h3
                    className="mb-0 d-flex gap-2 align-items-center"
                    style={{
                        whiteSpace: "nowrap",
                        fontWeight: 200,
                        fontSize: "22px",
                    }}
                >
                    All Projects
                </h3>
            </div>

            <div
                className="d-flex align-items-center gap-1"
                style={{ height: "80px" }}
            >
                {/* search bar */}
                <div className="position-relative">
                    <input
                        type="text"
                        style={{
                            fontSize: "12px",
                            paddingLeft: "58px",
                            height: "36px",
                        }}
                        className="form-control"
                        value={inputSearch}
                        onChange={(e) => {
                            setInputSearch(e.target.value)
                            setOffset(0)
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault()
                                setSearch(inputSearch)
                                setOffset(0)
                            }
                        }}
                    />
                    <i
                        className="fa-solid fa-magnifying-glass"
                        style={{
                            position: "absolute",
                            marginTop: "-26px",
                            zIndex: 1,
                            marginLeft: "13px",
                        }}
                    ></i>
                    {inputSearch.length > 0 && (
                        <i
                            className="fa-solid fa-xmark"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                right: 0,
                                marginRight: "13px",
                                cursor: "pointer",
                            }}
                            onClick={() => setInputSearch("")}
                        ></i>
                    )}
                </div>

                <ColumnConfigurator
                    columnOptions={columnOptions}
                    columns={columns}
                    setColumns={setColumns}
                    storageKey="projectColumns"
                    visibleKey="visibleProjectColumns"
                />

                <Button
                    style={{ height: "35px" }}
                    type="button"
                    variant="default"
                    className="btn btn-default"
                    onClick={() => {
                        if (!projectGrant?.isCreate) {
                            toast.warning("You are not authorized for this action!")
                            return
                        }
                        setProjectOffcanvas(true)
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Add
                </Button>
            </div>
        </div>
    )
}